import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../../../../functions/navigation/utils/wrapNavigatorScreen';

const ChatSettingsPageContent = lazy(
  () => import('./components/ChatSettingsPageContent'),
);

export const ChatSettingsPage = wrapLazyNavigatorScreen(
  () => {
    return <ChatSettingsPageContent />;
  },
  {
    headerShown: false,
  },
);
